import { render, staticRenderFns } from "./Observaciones.vue?vue&type=template&id=59e16306&scoped=true"
import script from "./Observaciones.vue?vue&type=script&lang=js"
export * from "./Observaciones.vue?vue&type=script&lang=js"
import style0 from "./Observaciones.vue?vue&type=style&index=0&id=59e16306&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e16306",
  null
  
)

export default component.exports